import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

type listMoreInformationTypesResponse = {
  moreInformationTypes: string[];
};

export const listMoreInformationTypes = async () => {
  const response = await executeApiRequest(() => axios.get<listMoreInformationTypesResponse>("/requests/moreinformationtypes"));
  return response?.data.moreInformationTypes;
};
